/**
 * @file Pure view component for item separator in notes list
 * @module features/notes/components/ItemSeparator/ItemSeparatorView
 * @description
 * Provides consistent vertical spacing between note items in section lists.
 * Used as ItemSeparatorComponent in SectionList and BottomSheetSectionList.
 */

import { memo, ReactElement } from "react";

import { Box } from "@/components/atoms/Box";

/**
 * Pure view component for item separator
 * @returns Separator element with 12px height (h-3)
 */
const ItemSeparatorView = (): ReactElement => <Box className="h-3" />;

ItemSeparatorView.displayName = "ItemSeparatorView";

export default memo(ItemSeparatorView);
